



export enum AnalysisConfigVisibilityFieldTypeValues {
    Defined = 'defined',
    Truthy = 'truthy',
    Falsey = 'falsey',
    Contains = 'contains',
    DoesNotContain = 'does_not_contain'
}

// Provide configurable field visibility
// Currently if any visible_config matches the field is visible
// Optionally configure visible_value to specify any defined value, or truthy/falsey value 
// should be considered a match for visibility. This overrides any defined visible_prop_values
export interface IAnalysisConfigVisibilityFieldTypeArgs {
    visible_configs: Array<{
        visible_prop_path: string,
        visible_prop_value: any,
        visible_value?: AnalysisConfigVisibilityFieldTypeValues,
        visible_parent?: string
    }>
}

export interface IAnalysisConfigRegularExpressionFieldTypeArgs {
    regex_pattern: string,
    regex_description?: string
    regex_data_type?: "number" | 'string'
}

export interface IAnalysisConfigArrayFieldTypeArgs {
    array_max_items?: number
}

// See AnalysisConfigsUiService.transformValueForValueMappedField or supported field_types
// Note that mapped fields may references fields anwhere in the configuration
// however they may only be defined on configurationLevel 1
export interface IAnaylsisConfigValueMappingFieldTypeArgs {

    value_map: {
        // straight mapping if only src_prop_path defind
        src_prop_path: string,
        preserve_existing: boolean,
        // conditional mapping of expected values 
        // optional dynamic value_prop_path to use based on src_prop_value 'value' of root src_prop_path
        src_value_conditions: Array<{ value_prop_path?: string, src_prop_value: any }>
    }

}


export interface IAnalysisConfigXorFieldTypeArgs {
    // must reference a field on the same object
    // as the v-model
    xor_alt_field_name: string,
    // Leave undefined in schema to use undefined as default
    // TOOD: for all XOR fields we delete the "other" key entirely and remove default
    xor_inactive_field_default_value?: any,
    xor_toggle_label?: string
}

export interface IAnalysisConfigSelectXorTextFieldTypeArgs extends IAnalysisConfigXorFieldTypeArgs {
    xor_use_column_options?: boolean
}

export interface IAnalysisConfigSelectXorSelectFieldTypeArgs extends IAnalysisConfigXorFieldTypeArgs {
    xor_use_column_options?: boolean
    xor_alt_field_options?: []
    xor_alt_field_use_column_options?: boolean
}

export interface IAnalysisConfigTextXorSelectFieldTypeArgs extends IAnalysisConfigXorFieldTypeArgs {
    xor_alt_field_options?: []
    xor_alt_field_use_column_options?: boolean
}
